// map ชื่อไอคอน → component · แยกไฟล์จาก icons.tsx เพราะไฟล์ที่ export
// ทั้ง component และค่าอื่นทำให้ fast refresh ของ Vite ใช้ไม่ได้
import {
  IconBox,
  IconChart,
  IconChat,
  IconCompass,
  IconFolder,
  IconGrid,
  IconLayout,
  IconMegaphone,
  IconTarget,
  IconLayers,
  IconTrend,
  IconUsers,
  IconWallet,
} from "./icons";

/** key ตรงกับ field icon ใน SIDE_MENUS ของเมนูด้านซ้าย */
export const MENU_ICONS = {
  grid: IconGrid,
  compass: IconCompass,
  megaphone: IconMegaphone,
  layout: IconLayout,
  chat: IconChat,
  wallet: IconWallet,
  target: IconTarget,
  chart: IconChart,
  trend: IconTrend,
  box: IconBox,
  layers: IconLayers,
  users: IconUsers,
  folder: IconFolder,
} as const;

export type MenuIconName = keyof typeof MENU_ICONS;
